import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import WelcomeOffer from "@/components/WelcomeOffer";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Menu from "@/pages/Menu";
import Reservations from "@/pages/Reservations";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <WelcomeOffer />
        <Toaster
          position="top-center"
          theme="light"
          toastOptions={{
            classNames: {
              toast: "border-[var(--infuse-gold)]/40 bg-white text-[var(--infuse-ink)]",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
